import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik} from 'formik';
import { Alert, Container, Form } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';

import { getSurveyUserForm, saveUseAnswers } from '../../../redux/survey/survey_user_form/actions';
import { schema } from './schema';
import { Loader } from '../../../components/loader/Loader';
import { renderQuestions } from './questions';
import StepQuestions from './components/StepQuestions';
import LoadingButton from '../../../components/loading_button/LoadingButton';
import { getUrlParams } from '../../../utils/urlParams';

const SurveyUserForm = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { surveyUserForm, isLoading, error, isLoadingSurveyUserForm } = useSelector(state => state.surveyUserForm);
  const { token, userId } = useSelector((store) => store.auth);
  const _schema = schema(surveyUserForm?.questions || []);
  
  useEffect(() => {
    dispatch(getSurveyUserForm({ survey_id: props.match.params.id }));
  }, [dispatch, props.match.params.id]);

  const onSubmit = (values) => {
    //Prepare data to send to the server 
    const payload = {
      user_id: surveyUserForm.isNeededLogin ? userId : null,
      surveyuser_id: surveyUserForm.surveyuser_id,
      survey_id: surveyUserForm.id,
      modo_prueba: getUrlParams('debugMode', location),
      respuestas: []
    }
    Object.entries(values).forEach(([key, value]) => {
      const questionIndex = key.split('_')[1];
      const question = surveyUserForm.questions[questionIndex];
      //if value is array of object and object contain value key, structure will be { fila_id: 1, value: value }
      
      if(Array.isArray(value) && value[0].value) {
        let answers = [];
        value.forEach((val, index) => {
          const fila_id = question.answers.filter(fila => fila.type === 'Fila')[index].id;
          answers.push({
            fila_id: fila_id,
            columna_id: val.value
          });
        });
        payload.respuestas.push({  
          id_pregunta: question.id,
          respuesta: answers
        });
      }else{
        payload.respuestas.push({
          id_pregunta: question.id,
          respuesta: value
        });
      }
    });
    dispatch(saveUseAnswers(payload, props.history));
  }

  useEffect(() => {
    if(surveyUserForm.isNeededLogin && !token) {
      props.history.push('/login');
    }
  }, [surveyUserForm, token, props]);

  return (
    <Formik
      initialValues={{}}
      validationSchema={_schema}
      onSubmit={onSubmit}
      enableReinitialize>
      {({ handleSubmit,
          handleChange,
          setFieldValue,
          handleBlur,
          values,
          touched,
          errors, }) => (
        <Form onSubmit={handleSubmit}>
          <Container>
            {
              error && (
                <Alert variant="danger" className="my-3">
                  <h6>{error} ;(</h6>
                </Alert>
              )
            }
            {
              getUrlParams('debugMode', location) && (
                <Alert variant="info" className="my-3">
                  Modo debug activado <Link to={`/encuestas`}>Volver</Link>
                </Alert>
              )
            }
            {
              isLoading ? (
                <Loader />
              ) : (!error && surveyUserForm?.questions?.length === 0) ? (
                <Alert variant="info" className="my-3">
                  No hay preguntas para mostrar
                </Alert>
              ) : (
                <>
                  {
                    surveyUserForm?.paginationQuestion === 'Una página por pregunta' ? (
                      <StepQuestions 
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        values={values}
                        touched={touched}
                        errors={errors}
                        setFieldValue={setFieldValue}
                        isLoading={isLoadingSurveyUserForm}
                        //questions={surveyUserForm?.questions}
                        //surveyUserFormName={surveyUserForm?.name}
                        //surveyUserFormDescription={surveyUserForm?.description}
                        //surveyImg={surveyUserForm?.photo}
                         />
                    ) : (
                      <>
                        <h1 className="display-2 mt-5">{ surveyUserForm.name }</h1>
                        {
                          surveyUserForm?.photo && 
                          <img src={`${process.env.REACT_APP_URL}${surveyUserForm?.photo}`} className="img-fluid" alt="survey" />
                        }
                        <p className="my-3">{ surveyUserForm.description }</p>
                        {
                          surveyUserForm?.questions?.map((question, index) => (
                            renderQuestions(question, index, handleChange, handleBlur, values, touched, errors, setFieldValue) 
                          ))
                        }
                        <LoadingButton
                          isLoading={isLoadingSurveyUserForm}
                          text="Enviar"
                          variant="primary"
                          type="submit"
                          disabled={isLoadingSurveyUserForm}
                          />
                      </>
                    )
                  }
                </>
              )
            }
          </Container>
        </Form>
      )}
    </Formik>
    
  )
}

export default SurveyUserForm